(function () {
  if (window.__productDiscountCodeInit) return;
  window.__productDiscountCodeInit = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-discount-copy]');
    if (!button) return;

    const targetId = button.getAttribute('data-copy-target');
    const target = targetId ? document.getElementById(targetId) : null;
    const code = target ? target.textContent.trim() : '';
    if (!code) return;

    const defaultLabel = button.getAttribute('data-copy-default') || 'Copy';
    const successLabel = button.getAttribute('data-copy-success') || 'Copied';
    const labelEl = button.querySelector('.product-discount-code__copy-label');

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      button.classList.add('is-copied');
      if (labelEl) labelEl.textContent = successLabel;

      window.clearTimeout(button._copyResetTimer);
      button._copyResetTimer = window.setTimeout(() => {
        button.classList.remove('is-copied');
        if (labelEl) labelEl.textContent = defaultLabel;
      }, 1800);
    } catch (error) {
      if (labelEl) labelEl.textContent = 'Error';
      window.setTimeout(() => {
        if (labelEl) labelEl.textContent = defaultLabel;
      }, 1800);
    }
  });
})();
